import { IAlterarDadosEmMassaRepasse } from "../../../Interfaces/Repasse/AtendimentosRepasse/AtendimentosRepasse";
import {
    IExportExcelRepasseFiltro,
    IGestaoRepasse,
    IGestaoRepasseFiltro,
} from "../../../Interfaces/Repasse/GestaoRepasse/GestaoRepasseInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarGestaoRepasseService(
    requestBody: IGestaoRepasseFiltro
) {
    return Service(
        Axios.post<IGestaoRepasse>(
            `/repasse/atendimentosrepasse/listargestaorepasses`,
            requestBody
        )
    );
}

export async function ExportarExcelRepasseService(
    requestBody: IExportExcelRepasseFiltro
) {
    return Service(
        Axios.post<Blob>(
            `/repasse/relatoriorepasse/listarfinanciamentorepasses`,
            requestBody,
            { responseType: "blob" }
        )
    );
}

export async function ExportarExcelAtendimentosRepasseService(
    SEG_ATENDIMENTOS: string,
    requestBody: IGestaoRepasseFiltro
) {
    return Service(
        Axios.post<Blob>(
            `/repasse/atendimentosrepasse/exportarexcelrepasse?SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}`,
            requestBody,
            { responseType: "blob" }
        )
    );
}

export async function AlterarDadosEmMassaRepasseService(
    requestBody: IAlterarDadosEmMassaRepasse
) {
    return Service(
        Axios.put(
            `/repasse/casorepassedados/alterarcasorepassedadosemmassa`,
            requestBody
        )
    );
}

export async function AlterarDadosExcelRepasseService(requestBody: FormData) {
    return Service(
        Axios.post(`/repasse/leituraupdateexcel/lerexcelrepasse`, requestBody)
    );
}

export async function LeituraUpdateExcelService(requestBody: Array<number>) {
    return Service(
        Axios.post<Blob>(
            `/repasse/leituraupdateexcel/exportardadosrepasseexcel`,
            requestBody,
            {
                responseType: "blob",
            }
        )
    );
}
